module.exports = __webpack_public_path__ + "img/nine-active.d2ad2950.svg";